import qs from "qs";
import axios from 'axios';
import { environment } from '../../../../environments/environment';
import { EcitListQuery, EcitListResponse, Esante } from '@med_poc/types';



/* finishes the OIDC authentication process */
export const authenticateWithOidc = async (code: string, code_verifier: string, uuid?: string) => {
  return new Promise(async (resolve, reject) => {
    let data = JSON.stringify({
      "code": code,
      "code_verifier": code_verifier,
      "UUID": uuid ?? undefined
    });

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${environment.apiUrl}api/esante/completeOIDClogin/`,
      headers: { 
        'Content-Type': 'application/json', 
      },
      data : data
    };

    let response = await axios.request(config)
    resolve(response.data)
    
 
  });
}

type GetUserStatusSuccess = Esante['getUserStatus']['ResponseData']['Success'];
type GetUserStatusError = Esante['getUserStatus']['Error'] 

export const getOIDCstatusAndExtend = async () : Promise<GetUserStatusSuccess | GetUserStatusError | unknown> => {
  
  const options = {
    method: 'POST',
    url: `${environment.apiUrl}api/esante/getUserStatus/`,
    headers: {}
  };


  try {
    const { data } = await axios.request<GetUserStatusSuccess | GetUserStatusError>(options);
    console.devlog(data);
    return data;
  } catch (error) {
    console.deverror(error);
  }

}

export const eCit = async (payload) => {
  const ECIT_ENDPOINT = `${environment.apiUrl}api/esante/ecit/`;

  const response = await axios.post(ECIT_ENDPOINT, payload, {
        // The controller returns 422 for XSD failures with a body we still
        // want to render; treat 4xx as non-throwing to reach the else branch of the calling component.
        validateStatus: (s) => s < 500,
      });

  return response;
}


export const getMyEcits = async (params: EcitListQuery): Promise<EcitListResponse> => {
  const queryString = qs.stringify(params, { encodeValuesOnly: true, skipNulls: true });
  const response = await axios({
    method: 'get',
    url: `${environment.apiUrl}api/e-cit/findChecked?${queryString}`,
    headers: { Accept: 'application/json' },
  });
  return response.data;
};
